import { handleErrorException, loading, success } from 'State/actions';

import * as types from './types';

export const getTransferOrderData = filtersOptions => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.TRANSFER_ORDER_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Transfer',
        filtersOptions
      );
      dispatch(success(types.TRANSFER_ORDER_LIST, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: 'Error',
        Message:
          'An error occurred while fetching order data. Please try again',
      };
      dispatch(
        handleErrorException(ex, types.TRANSFER_ORDER_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.TRANSFER_ORDER_LOADING, false));
    }
  };
};

export const getPrintTransferData = printRequestData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_PREVIEW_TRANSFER_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'Transfer/GetTransferPrint',
        printRequestData
      );
      if (response.data.Data) {
        dispatch({
          type: types.SET_PRINT_DATA,
          payload: response.data.Data,
        });
      }
    } catch (ex) {
      const defaultError = {
        Title: 'Error',
        Message:
          'An error occurred while Printing Transfer List. Please try again',
      };
      dispatch(
        handleErrorException(ex, types.PRINT_PREVIEW_ERROR, defaultError)
      );
    } finally {
      dispatch(loading(types.PRINT_PREVIEW_TRANSFER_LOADING, false));
    }
  };
};

export const clearTransferGridError = () => {
  return {
    type: types.CLEAR_TRANSFER_LIST_ERROR,
  };
};
export const setToDateMin = payload => {
  return {
    type: types.SET_TO_DATE_MIN,
    payload,
  };
};
export const setFromDateMax = payload => {
  return {
    type: types.SET_FROM_DATE_MAX,
    payload,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/state/TransferOrderList/actions.js